import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-termos-uso-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './termos-uso-modal.component.html',
  styleUrl: './termos-uso-modal.component.scss'
})
export class TermosUsoModalComponent {
  constructor(
    public dialogRef: MatDialogRef<TermosUsoModalComponent>
  ) {
    // Impede o fechamento ao clicar fora
    dialogRef.disableClose = true;
  }

  aceitar(): void {
    this.dialogRef.close(true);
  }

  recusar(): void {
    this.dialogRef.close(false);
  }
}
